import React from 'react';
import { Select } from 'antd';
import './StatusSelect.less';

const { Option } = Select;

interface StatusSelectProps {
  valueList: number[];
  statusList: string[];
  colorList: string[];
  value?: number;
  placeholder: string;
  width?: number;
  onChange?: (value: number) => void;
}

const StatusSelect: React.FC<StatusSelectProps> = ({ valueList, statusList, colorList, value, placeholder, width, onChange, ...restProps }) => {
  const handleChange = (value: number) => {
    if (onChange) {
      onChange(value);
    }
  };

  const selectedIndex = valueList.indexOf(value as number);

  return (
    <Select
      className="status-select"
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      style={{ backgroundColor: colorList[selectedIndex], width }}
      dropdownStyle={{ color: 'inherit' }}  // Dropdown color
      {...restProps}
    >
      {statusList.map((status, index) => (
        <Option key={valueList[index]} value={valueList[index]} style={{ color: colorList[index]}}>
          <span >{status}</span>
        </Option>
      ))}
    </Select>
  );
};

export default StatusSelect;


/*在react+AntD项目中，帮我写一个基于Ant-D Select组件的封装组件，要求如下：
StatusSelect组件拥有Select的所有常见属性(onChange等)，除此之外，还有额外的3个参数：valueList、statusList和colorList，
其中valueList代表状态的值数组，整数数组。
statusList代表状态的名称数组，字符串数组。
colorList代表颜色数组，字符串（十六进制）数组。

Select没有边框，border-radis为3，默认无选项，对应背景色为白色。
当选择某一项时比如为statusList[i]，背景色对应改为colorList[i]，对应的取值也是 valueList[i]

逻辑代码放到StatusSelect.tsx中，样式文件放到StatusSelect.css中。
*/